import { h as __h } from "preact";
import { Component } from "preact";
import html from "~/util/html.js";
import Icon from "~/component/Icon.js";
import adminStyle from "~/admin/lib/style.js";
/** @import { groupResponse } from "~/backend/validate.js"; */

/**
 * @extends {Component<Props>}
 *
 * @typedef {object} Props
 * @property {Pick<groupResponse, "id" | "org_id" | "name">} group
 */
export default class GroupChip extends Component {
  render() {
    const {
      group
    } = this.props;
    return __h("a", {
      href: "/org/" + group.org_id + "/groups/" + group.id,
      "class": adminStyle.chip
    }, __h(Icon, {
      name: "users",
      size: 12
    }), __h("span", {}, group.name));
  }
}